module.exports = __webpack_public_path__ + "fonts/3107C8_5_0.9c57a38.ttf";